import { createTrackingUtils } from "..";
import { useCallback } from "react";
import useProfiler from "../../../hooks/useProfiler";

const utils = createTrackingUtils({
  name: "web_flights_lve_index_genius_airlines_banner",
  stages: {
    buffer_all_users_on_index_page: 1,
    main_all_users_on_index_page: 2,
    us_users_on_index_page: 3,
    users_on_index_page_with_recent_search: 4,
    meta_users_on_index_page: 5,
    direct_users_on_index_page: 6
  },
  defaultStage: 1,
  goals: {
    genius_airlines_banner_clicked: 1,
    genius_airlines_banner_hovered: 2
  },
  goalsWithValue: ["genius_airlines_banner_viewed", "genius_airlines_banner_rendered"]
});

export default function useGeniusAirlinesBanner() {
  const { isAmerican, isDirect, isLoggedIn } = useProfiler();

  const trackHasRecentSearch = () => {
    utils.stages.users_on_index_page_with_recent_search();
  };

  const trackCustomGoalBannerClicked = () => {
    utils.goals.genius_airlines_banner_clicked();
  };

  const trackCustomGoalBannerHovered = () => {
    utils.goals.genius_airlines_banner_hovered();
  };

  const trackCustomGoalWithValueBannerViewed = () => {
    utils.goalsWithValue.genius_airlines_banner_viewed(1);
  };

  const trackCustomGoalWithValueBannerRendered = () => {
    utils.goalsWithValue.genius_airlines_banner_rendered(1);
  };

  const trackStagesAndGetVariant = useCallback(() => {
    if (!isLoggedIn()) return;

    const variant = utils.trackWithDefaultStage() > 0;
    utils.stages.main_all_users_on_index_page();
    isAmerican() ? utils.stages.us_users_on_index_page() : null;
    isDirect() ? utils.stages.direct_users_on_index_page() : utils.stages.meta_users_on_index_page();

    return variant;
  }, [isAmerican, isDirect, isLoggedIn]);

  return {
    trackHasRecentSearch,
    trackCustomGoalBannerClicked,
    trackCustomGoalWithValueBannerViewed,
    trackCustomGoalWithValueBannerRendered,
    trackCustomGoalBannerHovered,
    trackStagesAndGetVariant
  };
}
